import { CoreImageView } from '@core/widgets';
import { AssetsSvgMap } from '@libs/types';
import React from 'react';
import { getHref } from '../../Image/imageUtils';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from './paysendCard.module.css';

type TButtonRowCopy = {
    title: string;
    text?: string;
    onClick: (textToClipboard: string, description: string) => void;
};

export const ButtonRowCopy = ({ title, text, onClick }: TButtonRowCopy) => {
    return (
        <button className={styles.copyButton} onClick={() => onClick(text ?? '', title)}>
            <span>
                <TextCommon isWidget={false} content={title} options={{ variant: 'secondary', textColor: 'grey_72_lc' }} />
                <TextCommon isWidget={false} content={text} options={{ variant: 'main', textColor: 'black', margin: { top: 4 } }} />
            </span>
            <span className={styles.copyButtonIcon}>
                <CoreImageView
                    src={getHref(AssetsSvgMap.ic_copy)}
                    styleProps={{
                        iconColor: `var(--color-purple_100)`,
                    }}
                />
            </span>
        </button>
    );
};
